require('./stylesheet/style.scss');

angular.module('pages.accounts', [])

.config(config)

config.$inject = ['$stateProvider']

function config($stateProvider) {

    $stateProvider
        .state('pages.accounts', {
            url: 'accounts',
            template: require('./templates/index.html'),
            controller: require('./controllers/accounts.controller.js'),
            params: {
                newBillId: null
            },
            data: {
                restricted: true,
                iframe: false,
                breadcrumbs: 'MENU.PAYMENTS'
            },
            pageTrack: '/accounts'
        })
}

module.exports = 'pages.accounts';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/accounts/index.js
 ** module id = 256
 ** module chunks = 1
 **/